export const styles = () => ({
  root: {
    height: '100%',
    width: '100%',
    position: 'absolute',
  },
});
